const __DEV__ = false;

import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { useTheme, jsx } from '@emotion/react';
import { getStyles, sanitizeProps } from '../../styles/theme/index.js';
import { S } from './styles.js';
import mergeDefaultProps from '../../utils/merge-default-props.js';

var _excluded = ["as", "children", "dataTestId"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultProps = {
  isInline: false,
  isItalic: false,
  isUppercase: false,
  truncate: false
};
var defaultBodyProps = _objectSpread(_objectSpread({}, defaultProps), {}, {
  as: 'p',
  colorVariant: 'primary',
  variant: 'body2'
});
var defaultHeaderProps = _objectSpread(_objectSpread({}, defaultProps), {}, {
  as: 'h1',
  colorVariant: 'h',
  variant: 'h1'
});
var sanitizeDefaultProps = function sanitizeDefaultProps(p) {
  var isHeaderOrLabel = typeof p.as === 'string' && ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'label'].includes(p.as);
  if (!isHeaderOrLabel) {
    return defaultBodyProps;
  } else if (p.as && !p.variant) {
    return _objectSpread(_objectSpread({}, defaultHeaderProps), {}, {
      variant: p.as
    });
  }
  return defaultHeaderProps;
};
var TextInternal = function TextInternal(props, ref) {
  var resiTheme = useTheme();
  var propsInternal = mergeDefaultProps(props, sanitizeDefaultProps(props));
  var as = propsInternal.as,
      children = propsInternal.children,
      dataTestId = propsInternal.dataTestId,
      rest = _objectWithoutProperties(propsInternal, _excluded);
  var ComponentProp = as;
  return jsx(ComponentProp, _extends({
    ref: ref,
    css: function css(theme) {
      return [S.container(theme, propsInternal), getStyles('container', theme, propsInternal)];
    },
    "data-testid": dataTestId
  }, _defineProperty({}, "data-".concat(resiTheme.prefix, "-text"), ''), sanitizeProps(rest)), children);
};
TextInternal.displayName = 'TextInternal';
var Text = Object.assign( React.forwardRef(TextInternal), {
  displayName: 'Text'
});

export { Text };
//# sourceMappingURL=text.js.map
